export type marketType = { id: number; count: number };
export type periodType = { id: number; title: string };

export type comparisonDataType = {
  rk: number;
  ric: string;
  cc: string;
  code: string;
  sbi_exch: string;
  nm: string;
  ccy: string;
  last: string;
  pctchg: string;
  total: string;
  per: string;
  dividendYield: string;
  score: string;
  rating: string;
};

export type performanceDataType = {
  rk: number;
  ric: string;
  cc: string;
  code: string;
  sbi_exch: string;
  nm: string;
  ccy: string;
  last: string;
  pctchg1y: string;
  pctchg1m: string;
  pctchg3m: string;
  pctchg6m: string;
};

export type technicalDataType = {
  rk: number;
  ric: string;
  cc: string;
  code: string;
  sbi_exch: string;
  nm: string;
  ccy: string;
  last: string;
  pctchg1y: string;
  beta: string;
  avgVolume: string;
  rsi: string;
  sma5d: string;
  sma25d: string;
};

export type fundamentalDataType = {
  rk: number;
  ric: string;
  cc: string;
  code: string;
  sbi_exch: string;
  nm: string;
  ccy: string;
  last: string;
  pctchg1y: string;
  total: string;
  per: string;
  pbr: string;
  roe: string;
  dividendYield: string;
};

export type scoreDataType = {
  rk: number;
  ric: string;
  cc: string;
  code: string;
  sbi_exch: string;
  nm: string;
  ccy: string;
  last: string;
  pctchg1y: string;
  overall: string;
  earnings: string;
  fundamental: string;
  valuation: string;
  risk: string;
  momentum: string;
};

export type ratingDataType = {
  rk: number;
  ric: string;
  cc: string;
  code: string;
  sbi_exch: string;
  nm: string;
  ccy: string;
  last: string;
  pctchg1y: string;
  targetPrice: string;
  rating: string;
  analystsNum: string;
};

export type combinedDataType = {
  rk: number;
  ric: string;
  cc: string;
  code: string;
  sbi_exch: string;
  nm: string;
  ccy: string;
  last: string;
  pctchg1y: string;
  targetPrice: string;
  rating: string;
  analystsNum: string;
  pctchg1m: string;
  pctchg3m: string;
  pctchg6m: string;
  beta: string;
  avgVolume: string;
  rsi: string;
  sma5d: string;
  sma25d: string;
  total: string;
  per: string;
  pbr: string;
  roe: string;
  dividendYield: string;
  score: string;
  overall: string;
  earnings: string;
  fundamental: string;
  valuation: string;
  risk: string;
  momentum: string;
};

export type sortingType = {
  id: string;
  asc: boolean;
  option?: string;
};

export type eventType = {
  id: string;
  name: string;
  subName: string;
  date: string;
  category?: string;
  announcement: string;
  base: string;
  payment: string;
  dividend: string;
  exDividend: string;
};

export type dividendDataType = {
  fiscal_year: string[];
  dividend: number[] | string[];
  dividendYield: number[] | string[];
  dividendPayoutRatio: number[] | string[];
  history: dividendHistoryType[];
};

export type dividendHistoryType = {
  dividendExDate: string;
  rightAllotmentDate: string;
  payDate: string;
  price: string;
  frequency: string;
  fiscal_year: string;
};

//Type-Specific Props
export enum Region {
  International = 'international',
  ALL_ASX = 'all asx',
  AU = 'AU',
  US = 'US',
  All = 'all',
  Default = '',
}

export enum Type {
  All = 'all',
  StrongBuy = '1',
  Buy = '2',
  Hold = '3',
  Reduce = '4',
  Sell = '5',
}

export enum MarketIndex {
  All = 'all',
  XFL = 'XFL',
  XAO = 'XAO',
  XTL = 'XTL',
  XTO = 'XTO',
  XAE = 'XAE',
  XAF = 'XAF',
  XAG = 'XAG',
  XAT = 'XAT',
  XBK = 'XBK',
  XBN = 'XBN',
  XBT = 'XBT',
  XBW = 'XBW',
  XDI = 'XDI',
  XDJ = 'XDJ',
  XEC = 'XEC',
  XEJ = 'XEJ',
  XET = 'XET',
  XEW = 'XEW',
  XFE = 'XFE',
  XFJ = 'XFJ',
  XFN = 'XFN',
  XFR = 'XFR',
  XGD = 'XGD',
  XHJ = 'XHJ',
  XIJ = 'XIJ',
  XIN = 'XIN',
  XJM = 'XJM',
  XJO = 'XJO',
  XJR = 'XJR',
  XJS = 'XJS',
  XJT = 'XJT',
  XKO = 'XKO',
  XLD = 'XLD',
  XMD = 'XMD',
  XMJ = 'XMJ',
  XMM = 'XMM',
  XNI = 'XNI',
  XNJ = 'XNJ',
  XNT = 'XNT',
  XNV = 'XNV',
  XPJ = 'XPJ',
  XRE = 'XRE',
  XRI = 'XRI',
  XSJ = 'XSJ',
  XSO = 'XSO',
  XSY = 'XSY',
  XTJ = 'XTJ',
  XTX = 'XTX',
  XUJ = 'XUJ',
  XVI = 'XVI',
  XXJ = 'XXJ',
  DJI = 'DJI',
  FTSE = 'FTSE',
  IXIC = 'IXIC',
  N225 = 'N225',
  NDX = 'NDX',
  SPX = 'SPX',
  US10YT = 'US10YT',
  US30YT = 'US30YT',
}

export enum GroupingType {
  Sector = 'sector',
  // Add other grouping options as they become available
}

export enum ColorMetric {
  PercentageChange = 'pc',
  NetChange = 'nc',
  LastSale = 'ls',
}

export enum SizeMetric {
  PercentageChange = 'pc',
  MarketCap = 'mktcap',
  Volume = 'volume',
  Turnover = 'turnover',
}

export enum Geography {
  Domestic = 'domestic',
  International = 'international',
  Asia = 'asia',
  ASX = 'ASX',
  US = 'US',
  // Add as needed
}

export enum RankType {
  TotalVolume = 'AV',
  PricePercentageGain = 'PG',
  PricePercentageLoss = 'PL',
  PriceNetGain = 'NG',
  PriceNetLoss = 'NL',
  TotalTurnover = 'AM',
  // Add as needed
}

export enum TimePeriod {
  Day = '1D',
  Month = '1M',
  ThreeMonths = '3M',
  SixMonths = '6M',
  Year = '1YR',
}

export enum ThemeType {
  Direct = 'direct',
  Potter = 'potter',
  Desktop = 'desktop',
}

// export enum Sector {
//   All = '0',
//   Energy = '50',
//   BasicMaterials = '51',
//   Industrials = '52',
//   ConsumerCyclicals = '53',
//   ConsumerNonCyclicals = '54',
//   Financials = '55',
//   Healthcare = '56',
//   Technology = '57',
//   Utilities = '59',
//   RealEstate = '60',
//   Institutions = '61',
//   Government = '62',
//   Academic = '63',
// }

export enum FiscalYear {
  Latest = 'FY0',
  Prior1Year = 'FY1',
  Prior2Years = 'FY2',
  Prior3Years = 'FY3',
  Prior4Years = 'FY4',
  Prior5Years = 'FY5',
}

export enum WidgetMessageType {
  OnStockClick = 'onstockclick',
  Sector = 'sector',
  Index = 'index',
  Count = 'count',
  NoData = 'noData',
  Height = 'height',
  OverScroll = 'overscroll',
}
export enum WidgetNameSource {
  BalanceSheet = 'balanceSheet',
  BrokerRating = 'brokerRating',
  CashFlow = 'cashFlow',
  CompanyProfile = 'companyProfile',
  CompanyScore = 'companyScore',
  ConsensusRecommendation = 'consensusRecommendation',
  FullNews = 'fullNews',
  Heatmap = 'heatmap',
  IncomeStatement = 'incomeStatement',
  IndicesPeerComparison = 'indicesPeerComparison',
  Indices = 'indices',
  KeyRatios = 'keyRatios',
  MarketIndices = 'marketIndices',
  MiniChart = 'miniChart',
  MiniNews = 'miniNews',
  Ownership = 'ownership',
  PriceHistory = 'priceHistory',
  Screener = 'screener',
  FundScreener = 'fundScreener',
  SectorHeatmap = 'sectorHeatmap',
  SectorIndices = 'sectorIndices',
  SectorPeerComparison = 'sectorPeerComparison',
  StockPeerComparison = 'stockPeerComparison',
  TargetPrice = 'targetPrice',
  TopMovers = 'topMovers',
  CompanyEvent = 'companyEvent',
  CompanyDirector = 'companyDirector',
  DividendHistory = 'dividendHistory',
  Sentiment = 'sentiment',
  AdvanceChart = 'advanceChart',
  IndexChart = 'indexChart',
  FundSummary = 'fundSummary',
}

export enum DirectionType {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
}
// company event
export enum StartQualifier {
  DateTime = 'DateTime',
  DateOnly = 'DateOnly',
  BeforeMarketOpen = 'BeforeMarketOpen',
}

export enum EventType {
  All = 'all',
  Earning = 'earning',
  Dividend = 'dividend',
  StockSplit = 'stocksplit',
  MA = 'ma',
  Conference = 'conference',
  OtherType = 'othertype',
}
// company director

export enum DirectorOfficerStatus {
  Officer = 'Officer',
  Director = 'Director',
  Both = 'Both',
}

export enum DirectorSortBy {
  LastName = 'lastName',
  Title = 'title',
  OldPosition = 'oldPosition',
  LatestPosition = 'latestPosition',
  Compensation = 'compensation',
}

export enum DirectorOrderBy {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum SaleInCountry {
  AU = 'AU',
  US = 'US',
}
